import React from 'react';
import GenericCategoryItem, {
  GenericCategoryItemProps,
} from '../../../../components-library/menu/category/GenericCategoryItem';
import GiftCardCategoryItem from './GiftCardCategoryItem';
import { GiftIcon } from 'lucide-react';

const GiftCardCategory = (props: GenericCategoryItemProps) => {
  return (
    <GenericCategoryItem
      {...props}
      customTitle={
        <div className="flex items-center gap-2">
          <span>{props.category.name}</span>
          <GiftIcon className="text-brand-primary" />
        </div>
      }
    >
      <GenericCategoryItem.Products {...props}>
        <GiftCardCategoryItem />
      </GenericCategoryItem.Products>
    </GenericCategoryItem>
  );
};

export default GiftCardCategory;
